export default "__VITE_ASSET__zfg2bQYq__"